import { ROUTES } from '../../constants'
import client from '../client'

export const getEnabledConciergeLocationsKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Concierge/GetEnabledConciergeLocations`

/**
 * @typedef {object} Location
 *
 * @property {string} address1
 * @property {string} address2
 * @property {string} address3
 * @property {string} id
 * @property {string} label
 * @property {number} lat
 * @property {number} lng
 * @property {string} pageDescription
 * @property {string} pageTitle
 * @property {string} stateName
 * @property {string} value
 */
/**
 * @param {Location} location
 * @returns {Location & {href: string, title: string}}
 */
const mapLocation = (location) => ({
  ...location,
  href: ROUTES.Contact + '/' + location.value,
  title: location.address3,
})

export async function getEnabledConciergeLocations() {
  return client(`${getEnabledConciergeLocationsKey}`).then((res) => res.map(mapLocation))
}
